export function telegramInitOptions(tg, options = {}) {
  if (!tg) return;

  const {
    headerColor = "#ffffff",
    backgroundColor = "#ffffff",
    expand = true,
    confirmClose = true,
  } = options;

  try {
    // 🎨 Верхняя панель (header)
    if (headerColor) {
      tg.setHeaderColor(headerColor);
    }

    // 🎨 Нижний фон (background)
    if (backgroundColor) {
      tg.setBackgroundColor(backgroundColor);
    }

    // 📱 Полный экран
    if (expand) {
      tg.expand();
    }

    // ⚠️ Предупреждение при закрытии
    if (confirmClose) {
      tg.enableClosingConfirmation();
    }
  } catch (e) {
    // Telegram может молча падать на старых клиентах
    console.warn("Telegram init options failed", e);
  }
}
